import React from 'react';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import type { MuiTelInputCountry } from 'mui-tel-input';
import { getFlagUrl } from '../../../PhoneInput/utils';
import { Typography } from '../../../Typography';

interface FlagElementProps {
  isoCode: MuiTelInputCountry;
  countryName: string;
  isSelected: boolean;
}

export const FlagElement: React.FC<FlagElementProps> = ({ isoCode, countryName, isSelected }) => {
  if (isSelected) {
    return (
      <>
        <img width="24" height="24" src={getFlagUrl(countryName)} alt={countryName} />
        <Typography sx={{ fontSize: '16px', color: '#344054', px: '4px' }}>{isoCode}</Typography>
        <ExpandMoreIcon />
      </>
    );
  }
  return <img width="24" height="24" src={getFlagUrl(countryName)} alt={countryName} />;
};
